<template>
    <modal-wrapper modalClass="modal" :modalName="name" @before-open="setupData">
        <div class="modal__header">
            <h1>{{seller.name}}</h1>
            <h2>{{$t('modals.seller.label_subtitle')}}</h2>
        </div>
        <div class="modal__content">
            <loader class="table__responsive" :loading="api.loading" :error="api.error">
                <table class="table--hover--clickable">
                    <thead>
                        <tr>
                            <th>
                                {{$t('modals.seller.columns.buyer')}}
                            </th>
                            <th>
                                {{$t('modals.seller.columns.address')}}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="sale in seller.sales" @click="onSaleClicked(sale)">
                            <td>{{sale.buyer.name}}</td>
                            <td>{{sale.address}}</td>
                        </tr>
                    </tbody>
                </table>
            </loader>
        </div>
        <div class="modal__footer">
            <button class="button--cta" type="button" @click="$modal.hide(name)">
                {{$t('modals.seller.button_close')}}
            </button>
        </div>
    </modal-wrapper>
</template>
<script>
    import Vue from 'vue';
    import {Component} from 'vue-property-decorator';
    import ModalWrapper from '../general/ModalWrapper';
    import Loader from '../general/Loader';
    import {formatQuery} from '../../api/format-query';

    @Component({
        components: {
            ModalWrapper,
            Loader,
        }
    })
    export default class SellerModal extends Vue {
        name = 'seller-modal';
        api = {
            endpoint: 'dashboard/api/sales/contact_persons',
            loading: false,
            error: false,
        };
        query = {
            daterange: {},
            country_id: null,
            account_id: null,
        };
        seller = {
            id: 1,
            name: 'Nico Favresse',
            sales: [
                {
                    id: 1,
                    buyer: {id: 1, name: 'SomeBuyer'},
                    address: 'de Bjirk 2'
                },
                {
                    id: 2,
                    buyer: {id: 1, name: 'SomeBuyer'},
                    address: 'de Bjirk 2'
                },
                {
                    id: 3,
                    buyer: {id: 2, name: 'McRichFace'},
                    address: 'Rondestraat 9'
                },
                {
                    id: 4,
                    buyer: {id: 2, name: 'McRichFace'},
                    address: 'Rondestraat 9'
                },
            ]
        };

        setupData(modalOptions) {
            console.log('[ SellerModal ]', modalOptions);
            this.seller = modalOptions.params.seller;
            this.query = modalOptions.params.query;
            this.api.loading = true;
            this.api.error = false;
            this.querySellerData(this.seller.id)
                .catch(e => this.onQueryError(e))
                .then(response => this.onQueryData(response))
                .then(() => this.api.error = false)
                .catch(() => this.api.error = true)
                .finally(() => this.api.loading = false);
        }

        querySellerData(sellerId) {
            return this.axios.post(this.api.endpoint, {...formatQuery(this.query), google_calendar_id: sellerId});
        }

        onQueryError(error) {
            const status = error.response && error.response.status;
            if (status === 404) {
                return {data: []};
            } else {
                throw error;
            }
        }

        response = [{
            'id': 128466,
            'crm_contact_person_id': 43538,
            'action_timestamp': '03-05-2018 11:45',
            'completed': false,
            'name': 'Jeremy Gilson',
            'postal_code': '7340',
            'city_name': 'Colfontaine'
        }, {
            'id': 86259,
            'crm_contact_person_id': 36074,
            'action_timestamp': '21-01-2016 17:00',
            'completed': true,
            'name': 'Francine Natalis',
            'postal_code': '4053',
            'city_name': 'Embourg'
        }];

        onQueryData({data = []}) {
            this.seller.sales = data.map(entry => ({
                id: entry.id,
                buyer: {
                    id: entry.crm_contact_person_id,
                    name: entry.name,
                },
                address: entry.city_name + ' ' + entry.postal_code,
            }));
        }

        onSaleClicked(sale) {
            const redirects = this.$config.redirects;
            if (redirects && redirects.crm_contact_person) {
                window.open(redirects.crm_contact_person + sale.buyer.id, '_blank');
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/modals/SellerModal.vue